import React from 'react';

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <p>&copy; 2026 2CBNTV. All rights reserved.</p>
        <p>
          Email: <a href="mailto:info@2cbntv.co.za">info@2cbntv.co.za</a>
        </p>
        <p className="disclaimer">
          <strong>Disclaimer:</strong> We are not associated with the official 2CBNTV television network. 
          Please contact us if you have any queries or complaints.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
